import { render, staticRenderFns } from "./Dingdingda.vue?vue&type=template&id=078a3980&scoped=true&"
import script from "./Dingdingda.vue?vue&type=script&lang=js&"
export * from "./Dingdingda.vue?vue&type=script&lang=js&"
import style0 from "./Dingdingda.vue?vue&type=style&index=0&id=078a3980&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a3980",
  null
  
)

export default component.exports